import type * as THREE from 'three';
import { XRControllerModelFactory } from 'three/examples/jsm/webxr/XRControllerModelFactory.js';
import { XR } from '../config';

/**
 * VR 컨트롤러를 보이게 한다. XRControllerModelFactory가 WebXR 입력 프로파일에 맞는
 * 컨트롤러 모델을 자동 로드한다. dolly에 붙여 향후 로코모션 시 함께 이동하게 한다.
 *
 * 데스크탑에선 활성 XR 세션이 없으므로 아무 것도 그려지지 않는다(동작 변화 없음).
 * 로코모션 자체는 로드맵 단계에서 여기에 추가한다.
 */
export function setupControllers(renderer: THREE.WebGLRenderer, dolly: THREE.Object3D): void {
  const factory = new XRControllerModelFactory();

  for (let i = 0; i < XR.controllerCount; i++) {
    const grip = renderer.xr.getControllerGrip(i);
    grip.add(factory.createControllerModel(grip));
    dolly.add(grip);
  }
}
